import React from 'react';
import { Form, Modal, Row, Col } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import DevTaskService from 'services/DevTaskService';
import BootboxHelper from 'helpers/BootboxHelper';
import UserService from 'services/UserService';
import TagService from 'services/TagService';

// Components
import Loader from 'components/common/Loader';
import DatePicker from 'components/common/DatePicker';
import TagSelector from 'components/common/TagSelector';

//-------------------------------------------------------------------------------------------------------------------

class EditDevTaskModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.devTaskID = opts.devTaskID;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        let devTask;
        if (this.devTaskID) {
            devTask = await DevTaskService.get(this.devTaskID);
        } else {
            const loginInfo = GlobalStateService.getValue('loginInfo');
            devTask = {
                addedByUserID: loginInfo.user.id,
                status: 'New',
                tagIDs: []
            };
        }

        const users = await UserService.list({
            role: 'Admin'
        });
        const tags = await TagService.list({
            type: 'DevTask'
        });

        this.setState({
            devTask,
            users,
            tags,
            isLoading: false
        });
    }

    updateFields(values) {
        const devTask = { ...this.state.devTask };
        for (var field in values) {
            let value = values[field];
            devTask[field] = value;
            if (field == 'status' && value == 'Live' && !devTask.dateCompleted) {
                devTask.dateCompleted = moment().format('YYYY-MM-DD');
            }
        }
        this.setState({
            devTask
        });
    }

    async saveAndClose() {
        this.setState({
            isLoading: true
        });
        try {
            await DevTaskService.save(this.state.devTask);
            this.close();
            this.resolve();
        } catch (error) {
            BootboxHelper.alert(error);
            this.setState({
                isLoading: false
            });
        }
    }

    async confirmDelete() {
        const confirm = await BootboxHelper.confirm('Are you sure you want to delete this task?');
        if (confirm) {
            this.delete();
        }
    }

    async delete() {
        this.setState({
            isLoading: true
        });
        await DevTaskService.delete(this.state.devTask.id);
        this.close();
        this.resolve();
    }

    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (<>

            <Modal show className="edit-dev-task-modal">
                {this.renderInner()}
            </Modal>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            devTask,
            users,
            tags
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader />
                </Modal.Body>
            );
        }

        const statuses = DevTaskService.listStatuses();

        return (

            <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }}>
                <Modal.Body>

                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <input
                            className="form-control"
                            type="text"
                            value={devTask.title}
                            onChange={e => this.updateFields({ title: e.target.value })}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <textarea
                            className="form-control"
                            type="number"
                            value={devTask.description}
                            onChange={e => this.updateFields({ description: e.target.value })}
                            rows={10}
                        />
                    </Form.Group>

                    <Row>

                        <Col md="6">

                            <Form.Group className="mb-3">
                                <Form.Label>Requested By</Form.Label>
                                <select
                                    className="form-control"
                                    value={devTask.addedByUserID || ''}
                                    onChange={e => this.updateFields({ addedByUserID: e.target.value })}
                                >
                                    <option value="">(Select)</option>
                                    {users.map(user =>
                                        <option key={user.id} value={user.id}>
                                            {user.firstName} {user.lastName}
                                        </option>
                                    )}
                                </select>
                            </Form.Group>

                        </Col>

                        <Col md="3">

                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <select
                                    className="form-control"
                                    value={devTask.status || ''}
                                    onChange={e => this.updateFields({ status: e.target.value })}
                                >
                                    {statuses.map(status =>
                                        <option key={status} value={status}>
                                            {DevTaskService.getStatusFriendly(status)}
                                        </option>
                                    )}
                                </select>
                            </Form.Group>

                        </Col>

                        <Col md="3">

                            {devTask.status == 'Live' &&
                                <Form.Group className="mb-3">
                                    <Form.Label>Date completed</Form.Label>
                                    <DatePicker
                                        className="form-control"
                                        selected={devTask.dateCompleted ? new Date(devTask.dateCompleted) : null}
                                        onChange={value => this.updateFields({ dateCompleted: value })}
                                    />
                                </Form.Group>
                            }

                        </Col>

                    </Row>

                    {/*
                    <Form.Group className="mb-3">
                        <Form.Label>Estimated Completion Date</Form.Label>
                        <DatePicker
                            className="form-control"
                            selected={devTask.estCompletionDate ? new Date(devTask.estCompletionDate) : null}
                            onChange={value => this.updateFields({ estCompletionDate: value })}
                        />
                    </Form.Group>
                    */}

                    <Form.Group className="mb-3">
                        <Form.Label>Tags</Form.Label>
                        <TagSelector
                            creatable
                            type="DevTask"
                            tagIDs={devTask.tagIDs}
                            onChange={tagIDs => this.updateFields({ tagIDs })}
                        />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Close
                    </button>
                    {devTask.id &&
                        <button type="button" className="btn btn-danger ms-auto me-auto" onClick={() => this.confirmDelete()}>
                            Delete
                        </button>
                    }

                    <button type="submit" className="btn btn-primary ms-auto">
                        Save
                    </button>
                </Modal.Footer>
            </form>
        );
    }
}

export default EditDevTaskModal;